export interface IPagination {
  limit?: number;
  skip?: number;
  total?: number;
}
export class Pagination {
  /**
   *
   */

  limit?: number;
  skip?: number;
  total?: number;

  constructor(partial: Partial<IPagination>) {
    Object.assign(this, partial);
  }
}


// WEBPACK FOOTER //
// ./src/models/generic/generic-pagination.ts